<template lang="html">
  <error-page-layout
    color-type="error"
    error-type="Sessão expirada"
    first-message="Você ficou inativo por muito tempo ou entrou com essa conta em outro dispositivo e foi desconectado por motivos de segurança."
    image-name="expired.png"
    title="Sua sessão expirou"
  >
    <v-btn slot="buttons" color="orange" dark text @click="redirect">Fazer login novamente</v-btn>
  </error-page-layout>
</template>

<script>
import { formattedRedirectLogout } from '@/helpers/login'
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'

export default {
  components: {
    ErrorPageLayout,
  },
  methods: {
    async redirect() {
      const singleLoginURL = this.$microservicesUrls['mfLogin']
      const host = location.href.slice(0, location.href.indexOf('#'))
      const hash = window.localStorage.getItem('redirectAfterLogin') || ''

      this.$logout()
      window.location.href = formattedRedirectLogout(singleLoginURL, host, hash)
    },
  },
}
</script>
